






























































import {
  getMemberClientIds,
  getClientsByIds,
  getClientId,
  getMemberClientsConfiguration,
  updateMemberClientsUserSettings
} from "@/data/repository/ClientRepository";
import { Vue, Component, Ref } from "vue-property-decorator";
import Client, { 
  MemberClientsConfiguration, 
  createDefaultMemberClientsConfiguration,
} from "@/data/models/Client";
import router from "@/router/router";
import MultiSelectionPickerComponent from "@/components/common/MultiSelectionPicker.vue";
import PickerDialogComponent from "@/components/common/PickerDialog.vue";
import ConfirmationDialogComponent from "@/components/common/ConfirmationDialog.vue";
import { ToolbarContentModule } from "@/store/modules/ToolbarContent";
import { COLOR_BUTTON_SETTINGS_SAVE, COLOR_BUTTON_SETTINGS_EDIT } from "@/utils/colors";
import { themedFill, themedFillTextClass } from "@/utils/Theme";

@Component({
  components: {
    picker: PickerDialogComponent,
    "confirmation-dialog": ConfirmationDialogComponent,
    "multi-selection-picker": MultiSelectionPickerComponent,
  },
})
export default class UserSettingsAdministrationComponent extends Vue {
  isLoading = false;
  isIntiallyLoading = true;
  isEditMode = false;

  yesNoValues = [true, false];
  memberClients = new Map<string, Client>();

  memberClientsConfiguration: MemberClientsConfiguration = createDefaultMemberClientsConfiguration();
  initialUserSettingsAdministration = this.getUserSettingsAdministration();

  selectableClients = this.memberClientIds;

  showingSuccessSnackbar = false;
  successSnackbarText = "";
  
  get buttonColor() {
    return themedFill(this.isEditMode
      ? COLOR_BUTTON_SETTINGS_SAVE
      : COLOR_BUTTON_SETTINGS_EDIT);
  }

  get buttonTextClass() {
    return themedFillTextClass(this.isEditMode
      ? COLOR_BUTTON_SETTINGS_SAVE
      : COLOR_BUTTON_SETTINGS_EDIT, "white--text");
  }

  @Ref("confirm")
  confirmationDialogComponent!: ConfirmationDialogComponent;

  get hasChanged() {
    return (
      this.memberClientsConfiguration.defineOwnUserSettings !== this.initialUserSettingsAdministration.defineOwnUserSettings ||
      this.memberClientsConfiguration.memberClientsWithOwnUserSettings !== this.initialUserSettingsAdministration.memberClientsWithOwnUserSettings
    );
  }

  get readonly() {
    return !this.isEditMode;
  }

  get memberClientIds() {
    return getMemberClientIds().filter(id => id !== getClientId());
  }

  get showMemberClientsSelector() {
    return this.memberClientsConfiguration.defineOwnUserSettings;
  }

  getUserSettingsAdministration() {
    return {
      defineOwnUserSettings: this.memberClientsConfiguration?.defineOwnUserSettings,
      memberClientsWithOwnUserSettings: this.memberClientsConfiguration?.memberClientsWithOwnUserSettings
    };
  }

  get formatYesNo() {
    return (value: boolean) => {
      return this.$t(`common.${value ? "yes" : "no"}`).toString();
    };
  }

  get selectableClientsFormatter() {
    return (memberClientId: string) => {
      const client = this.memberClients.get(memberClientId);

      if (!client) {
        return null;
      }

      const clientName =
        !client.companyName || client.companyName === ""
          ? client.clientName
          : client.companyName;

      return clientName;
    };
  }

  async created() {
    this.isIntiallyLoading = true;
    this.memberClients = await getClientsByIds(this.memberClientIds);
    const activeMemberClientIds = Array.from(this.memberClients.keys());

    this.memberClientsConfiguration = getMemberClientsConfiguration(activeMemberClientIds);
    this.initialUserSettingsAdministration = this.getUserSettingsAdministration();
    this.isEditMode = false;
    
    this.isIntiallyLoading = false;
  }

  async onSave() {
    if (!this.isEditMode) {
      this.isEditMode = true;
      return;
    }

    if (!this.hasChanged) {
      return;
    }

    this.isLoading = true;
    const result = await updateMemberClientsUserSettings(this.memberClientIds, this.memberClientsConfiguration);

    this.isLoading = false;
    
    if (result) {
      this.showingSuccessSnackbar = true;
      this.successSnackbarText = this.$t("common.changesSaved").toString();
      
      this.initialUserSettingsAdministration = this.getUserSettingsAdministration();
      this.isEditMode = false;
    }
  }

  async onBack() {
    if (this.isEditMode) {
      if (this.hasChanged) {
        const result = await this.confirmationDialogComponent.show({
          title: this.$t("common.confirmationDialog.cancelTitle").toString(),
          message: this.$t("common.confirmationDialog.cancelMessage").toString(),
        });

        if (result) {
          this.memberClientsConfiguration.defineOwnUserSettings = this.initialUserSettingsAdministration.defineOwnUserSettings;
          this.memberClientsConfiguration.memberClientsWithOwnUserSettings = this.initialUserSettingsAdministration.memberClientsWithOwnUserSettings;
          this.isEditMode = false;
          return;
        }

        return;
      }

      this.isEditMode = false;
      return;
    }

    router.back();
  }

  mounted() {
    this.setToolbarTitle();
  }

  setToolbarTitle() {
    const baseTitle = this.$t("pages.settings").toString();
    const currentPageTitle = this.$t("settings.administration.userSettings.title").toString();

    const toolbarTitle = baseTitle + " > " + currentPageTitle;

    ToolbarContentModule.setToolbarTitle(toolbarTitle);
  }
}
